import { render } from "./SaleDetailsModal.vue?vue&type=template&id=231b89f6&scoped=true"
import script from "./SaleDetailsModal.vue?vue&type=script&lang=js"
export * from "./SaleDetailsModal.vue?vue&type=script&lang=js"

import "./SaleDetailsModal.vue?vue&type=style&index=0&id=231b89f6&scoped=true&lang=css"

import exportComponent from "/home/q4-cockpitmdwareorg/q4-cockpit.mdware.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-231b89f6"]])

export default __exports__